import { render, staticRenderFns } from "./InventoryDetail.vue?vue&type=template&id=72db695e"
import script from "./InventoryDetail.vue?vue&type=script&lang=js"
export * from "./InventoryDetail.vue?vue&type=script&lang=js"
import style0 from "./InventoryDetail.vue?vue&type=style&index=0&id=72db695e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports